<div class="countdown-wrapper">
  <!-- Offer Start Countdown -->
  <div class="status-badge">OFFER STARTS IN</div>
  <div class="countdown-container">
    <div class="time-unit">
      <div class="digits">{{ startDays }}</div>
      <span class="label">Days</span>
    </div>
    <div class="separator">:</div>
    <div class="time-unit">
      <div class="digits">{{ startHours }}</div>
      <span class="label">Hours</span>
    </div>
    <div class="separator">:</div>
    <div class="time-unit">
      <div class="digits">{{ startMinutes }}</div>
      <span class="label">Minutes</span>
    </div>
    <div class="separator">:</div>
    <div class="time-unit">
      <div class="digits">{{ startSeconds }}</div>
      <span class="label">Seconds</span>
    </div>
  </div>

  <!-- Offer End Countdown -->
  <div  class="status-badge">OFFER ENDS IN</div>
  <div class="countdown-container">
    <div class="time-unit">
      <div class="digits">{{ endDays }}</div>
      <span class="label">Days</span>
    </div>
    <div class="separator">:</div>
    <div class="time-unit">
      <div class="digits">{{ endHours }}</div>
      <span class="label">Hours</span>
    </div>
    <div class="separator">:</div>
    <div class="time-unit">
      <div class="digits">{{ endMinutes }}</div>
      <span class="label">Minutes</span>
    </div>
    <div class="separator">:</div>
    <div class="time-unit">
      <div class="digits">{{ endSeconds }}</div>
      <span class="label">Seconds</span>
    </div>
  </div>

  <div *ngIf="!isOfferActive && !isCountdownVisible" class="offer-ended">
    <p>🎉 Offer has ended!</p>
  </div>

  <div class="details-container">
    <div class="offer-details">
      <span class="date-label">Offer Starts</span>
      <span class="date-value">{{formattedOfferStart}}</span>
    </div>
    <div class="offer-details">
      <span class="date-label">Offer Ends</span>
      <span class="date-value">{{formattedOfferEnd}}</span>
    </div>
  </div>
</div>

